
























































































import { BButton, BFormGroup, BFormInput, BFormSelect } from "bootstrap-vue";
import { computed, PropType, ref, defineComponent } from "@vue/composition-api";
import {
    ButtonCategory,
    ButtonType,
    TemplateComponentPhoneButtonsInterface,
    TemplateInterface,
} from "@/interfaces/template.interface";
import useMessageTemplates from "@/composables/useMessageTemplates";
import DescriptionInputCounter from "@/views/modules/settings/whatsapp-templates/components/descriptionInputCounter.vue";
import { ValidationProvider } from "vee-validate";

export default defineComponent({
    components: { ValidationProvider, DescriptionInputCounter, BFormGroup, BFormSelect, BButton, BFormInput },
    props: {
        value: {
            required: true,
            type: Object as PropType<TemplateComponentPhoneButtonsInterface>,
        },
        changeableType: {
            type: Boolean,
            required: true,
        },
    },
    setup(props, { emit }) {
        const { callToActionButtonTypes } = useMessageTemplates();

        const phoneButton = computed<TemplateComponentPhoneButtonsInterface>({
            get: () => props.value,
            set: (value) => emit("input", value),
        });

        const callToActionTypeSelected = ref(ButtonType.PHONE);

        return {
            phoneButton,
            callToActionTypeSelected,
            callToActionButtonTypes,
        };
    },
});
